import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { selectGame } from "src/store/game"
import { documentTitleFor } from "src/utils/documentTitle"

/* Writes the tab's title on every navigation and every change of language (`utils/documentTitle`
   has why). Mounted once, beside `LanguageInPath`. The round is read only off the game the URL
   names: the viewed slot can still hold the last game for a render after the address moves. */
const DocumentTitle = () => {
  const { pathname } = useLocation()
  const { t, i18n } = useTranslation()
  const game = useSelector(selectGame)
  const gameInPath = pathname.match(/^\/game\/([^/]+)/)?.[1]
  const round = game && gameInPath != null && String(game.id) === gameInPath ? game.tick ?? null : null

  useEffect(() => {
    document.title = documentTitleFor(pathname, t, { round })
  }, [pathname, round, t, i18n.resolvedLanguage])

  return null
}

export default DocumentTitle
